// pagination
const marginBetweenTabs = parseInt(getComputedStyle(document.querySelectorAll(".dossierHeader__tab")[1]).marginLeft);
const nbTabs = document.querySelectorAll(".dossierHeader__tab").length;
const tabWidth = document.querySelector(".dossierHeader__tab").offsetWidth + marginBetweenTabs;
const buttonWidth = document.querySelector(".dossierHeader__tabButton").offsetWidth;
const tabsElement = document.querySelector(".dossierHeader__tabs");
const tabsContainer = document.querySelector(".dossierHeader__tabsContainer");
const tabsPageIndicator = document.querySelector(".dossierHeader__tabsPageIndicator");
const prevButtonElement = document.getElementById("prevButton");
const nextButtonElement = document.getElementById("nextButton");
let lastPagePadding;
let page;
let tabsPerPage;
let nbPages;
let pageWidth;
let currentWindowWidth = 0;

const initializeListeners = () => {
    window.addEventListener("resize", () => {
        if (currentWindowWidth !== window.innerWidth) {
            currentWindowWidth = window.innerWidth;
            calculateScrollValues();
            makeInitialScroll();
        }
    });
    prevButtonElement.addEventListener("click", () => {
        if (page > 0) {
            page--;
        }
        scrollToPage();
    });
    nextButtonElement.addEventListener("click", () => {
        if (page < nbPages - 1) {
            page++;
        }
        scrollToPage();
    });
};

const getActiveTabIndex = () => {
    let activeIndex = -1;
    document.querySelectorAll(".dossierHeader__tab").forEach((tab, index) => {
        if (tab.classList.contains("dossierHeader__tab--active")) {
            activeIndex = index;
        }
    });
    return activeIndex;
};

const calculateScrollValues = () => {
    tabsPerPage = Math.floor((tabsContainer.offsetWidth - (buttonWidth * 2)) / tabWidth);
    if (tabsPerPage < 1) {
        tabsPerPage = 1;
    }
    lastPagePadding = (tabsPerPage - (nbTabs % tabsPerPage) + 1) * tabWidth;
    tabsElement.style.paddingRight = (lastPagePadding + buttonWidth) + "px";

    pageWidth = (tabWidth * tabsPerPage);
    nbPages = Math.ceil(nbTabs / tabsPerPage);
};

const scrollToPage = (behaviour = "smooth") => {
    tabsElement.scroll({
        top: 0,
        left: pageWidth * page,
        behavior: behaviour,
    });
    setPageIndicator();
    changeButtonsModifiers();
};

const setPageIndicator = () => {
    tabsPageIndicator.innerHTML = "";
    for (let i = 0; i < nbPages; i++) {
        const indicatorItem = document.createElement("div");
        indicatorItem.classList.add("dossierHeader__tabsPageIndicatorItem");

        if (i === page) {
            indicatorItem.classList.add("dossierHeader__tabsPageIndicatorItem--active");
        }

        tabsPageIndicator.appendChild(indicatorItem);
    }
};

const changeButtonsModifiers = () => {
    nextButtonElement.classList.remove("dossierHeader__tabButton--disabled");
    prevButtonElement.classList.remove("dossierHeader__tabButton--disabled");
    if (page === 0) {
        prevButtonElement.classList.add("dossierHeader__tabButton--disabled");
    }
    if (page === nbPages - 1) {
        nextButtonElement.classList.add("dossierHeader__tabButton--disabled");
    }
};

const makeInitialScroll = (behaviour) => {
    page = Math.floor(getActiveTabIndex() / tabsPerPage);
    scrollToPage(behaviour);
};

initializeListeners();
calculateScrollValues();
makeInitialScroll("instant");
